import { hasValue } from "../../../utils/functions.js";

import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";
import BankConciliationModal from "./BankConciliationModal.vue";

const methods = {
  BankAgency: function (data) {
    return data.BankAgency + '-' + data.BankAgencyDigit;
  },
  BankAccount: function (data) {
    return data.BankAccount + '-' + data.BankAccountDigit;
  },
  BankAgencyLabel: function (data) {
    return 'Ag: ' + data.BankAgency + '-' + data.BankAgencyDigit;
  },
  BankAccountLabel: function (data) {
    return 'CC: ' + data.BankAccount + '-' + data.BankAccountDigit;
  },
  LabelButtonTable: function (data){
    return data.IsConciliated ? 'Visualizar' : 'Conciliar';
  },
  ColorButtonTable: function (data){
    return 'background: ' + (data.IsConciliated ? 'aliceblue' : '#ccffcc') + '; color: #5A6169;';
  }
}

export default {
  name: "BankConciliation",
  components: {
    TableList,
    DateField,
    DecimalField,
    BankConciliationModal,
    VueTypeaheadBootstrap
  },
  data() {
    return {
      pageName: 'Conciliação Bancária',
      permissionName: 'BankConciliation',
      headers: [
        { field: "EntryDate", label: "Data", type: 'date', classHeader: 'text-left', classField: 'text-left' },
        { field: function(data) { return data; }, label: "Conta Bancária", type: 'bankAccountWithLogo', classHeader: 'text-left', classField: 'text-left' },
        { field: "Amount", label: "Valor", type: 'currency', classHeader: 'text-left', classField: 'text-left' },
        { field: "EntryType.Code", label: "Operação", type: 'entryTypeBadge', classHeader: 'text-center', classField: 'text-center' },
        { field: "Description", label: "Descrição", classHeader: 'text-left', classField: 'text-left same-line' },
        { field: function(data) { return data.IsConciliated ? data.CategoryName : null; }, label: "Categoria", type: 'categoryOrPendingBadge', classHeader: 'text-left', classField: 'text-left' },
        { field: function(data) { return data.IsConciliated ? data.ConciliationInsertMode : null; }, label: "Modo", type: 'insertModeBadge', classHeader: 'text-center', classField: 'text-center' },
      ],
      additionalActions: [
        { authorization: 'Update', name: 'Conciliate', label: methods.LabelButtonTable, icon: 'fas fa-exchange-alt', style: methods.ColorButtonTable }
      ],
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      countFilter: 0,

      bankConciliationList: [],
      selectedBankConciliation: null,
      titleConciliateModal: "Conciliação de Lançamento Bancário",

      categorySearch: "",
      filterBankSearch: "",
      filterBankAccountSearch: "",
      filterAux:{
        AccountsCategory: null,
        BankAccounts: []
      },
      filterOptions: {
        Banks: [],
        BankAccounts: [],
        EntryTypes: [],
        AccountsPayableCategory: [],
        AccountsReceivableCategory: [],
      },
      filter: this.FilterDefault(),

      loading: {
        BankConciliation: false,
        BankAccounts: false,
        EntryType: false,
        AccountsPayableCategory: false,
        AccountsReceivableCategory: false
      },

      hasSearched: false,
      initializing: true
    };
  },

  mounted() {
    Promise.all([
      this.ListBankAccounts(),
      this.ListEntryTypes(),
      this.ListPayableCategories(),
      this.ListReceivableCategories(),
    ])
      .then(() => this.$nextTick(() => { this.initializing = false; this.OpenModalFilter(); }))
      .catch(() => this.$nextTick(() => { this.initializing = false; this.OpenModalFilter(); }));
  },

  computed: {
    allCategories() {
      const receivable = this.filterOptions.AccountsReceivableCategory.map(c => ({ ...c, Type: 'Receivable', DisplayName: c.Name + ' (Receber)' }));
      const payable = this.filterOptions.AccountsPayableCategory.map(c => ({ ...c, Type: 'Payable', DisplayName: c.Name + ' (Pagar)' }));
      return [...receivable, ...payable].sort((a, b) => a.Name.localeCompare(b.Name));
    },
    tableName(){
      const dateIni = this.$options.filters.date(this.filter.DateInitial);
      const dateEnd = this.$options.filters.date(this.filter.DateEnd);
      return this.pageName + ': ' + dateIni + ' á ' + dateEnd;
    },
    isLoading() {
      return this.loading.BankConciliation || this.loading.BankAccounts || this.loading.EntryType ||
             this.loading.AccountsPayableCategory || this.loading.AccountsReceivableCategory;
    },
    filterData(){
      return {
        filter: this.filter,
        filterOptions: this.filterOptions,
        filterAux: this.filterAux
      }
    },
    isFilterDateInvalid(){
      return this.filter.DateInitial > this.filter.DateEnd;
    },
    isFilterAmountInvalid(){
      return hasValue(this.filter.AmountInitial) && hasValue(this.filter.AmountEnd) && this.filter.AmountInitial > this.filter.AmountEnd;
    },
    summary() {
      return {
        UnconciliatedBankAccount:{
          items: [
            {
              label: '+Créditos:', style: "color: green",  icon: 'fas fa-arrow-up',
              releaseQtd: this.summaryData.BankStatementDetailsCreditQtd, 
              amount: this.summaryData.BankStatementDetailsCreditTotal
            },
            {
              label: '-Débitos:', style: "color: red",  icon: 'fas fa-arrow-down',
              releaseQtd: this.summaryData.BankStatementDetailsDebitQtd, 
              amount: this.summaryData.BankStatementDetailsDebitTotal
            },
          ],
          total: {
            label: 'Total:', style: "color: "+this.DefineColor(this.summaryData.UnconciliatedBankAccountTotal),  icon: 'fas fa-exchange-alt',
            releaseQtd: this.summaryData.UnconciliatedBankAccountQtd, 
            amount: this.RemoveNegative(this.summaryData.UnconciliatedBankAccountTotal), 
          }
        },
        UnconciliatedFinancial:{
          items: [
            {
              label: '+Contas a receber:', style: "color: green",  icon: 'fas fa-arrow-up',
              releaseQtd: this.summaryData.AccountsReceivableQtd, 
              amount: this.summaryData.AccountsReceivableTotal
            },
            {
              label: '-Contas a pagar:', style: "color: red",  icon: 'fas fa-arrow-down',
              releaseQtd: this.summaryData.AccountsPayableQtd, 
              amount: this.summaryData.AccountsPayableTotal
            },
          ],
          total: {
            label: 'Total:', style: "color: "+this.DefineColor(this.summaryData.UnconciliatedFinancialTotal),  icon: 'fas fa-exchange-alt',
            releaseQtd: this.summaryData.UnconciliatedFinancialQtd, 
            amount: this.RemoveNegative(this.summaryData.UnconciliatedFinancialTotal), 
          }
        },
        Entries:{
          items: [
            {
              label: '+Créditos:', style: "color: green",  icon: 'fas fa-arrow-up',
              releaseQtd: this.summaryData.BankStatementDetailsCreditQtd, 
              amount: this.summaryData.BankStatementDetailsCreditTotal
            },
            {
              label: '+Contas a receber:', style: "color: green",  icon: 'fas fa-arrow-up',
              releaseQtd: this.summaryData.AccountsReceivableQtd, 
              amount: this.summaryData.AccountsReceivableTotal
            },
          ],
        },
        Exits:{
          items: [
            {
              label: '-Débitos:', style: "color: red",  icon: 'fas fa-arrow-down',
              releaseQtd: this.summaryData.BankStatementDetailsDebitQtd, 
              amount: this.summaryData.BankStatementDetailsDebitTotal
            },
            {
              label: '-Contas a pagar:', style: "color: red",  icon: 'fas fa-arrow-down',
              releaseQtd: this.summaryData.AccountsPayableQtd, 
              amount: this.summaryData.AccountsPayableTotal
            },
          ],
        },
      }
    }
  },

  watch: {
    "pagination.PageNumber": function () {
      if (this.hasSearched) this.ListBankConciliation();
    },
    "pagination.RowsPerPage": function () {
      if (this.hasSearched) this.ListBankConciliation();
    },
    "filterAux.AccountsCategory": function () {
      //Feito dessa forma pois é preciso diferenciar os 2 ao enviar ao back, pois os 2 podem ter o mesmo code.
      if(this.filterAux.AccountsCategory){
        if(this.filterAux.AccountsCategory.Type == "Receivable"){
          this.filter.AccountsReceivableCategoryCode = this.filterAux.AccountsCategory.Code;
          this.filter.AccountsPayableCategoryCode = null;
        }else if(this.filterAux.AccountsCategory.Type == "Payable"){
          this.filter.AccountsPayableCategoryCode = this.filterAux.AccountsCategory.Code;
          this.filter.AccountsReceivableCategoryCode = null;
        }
      }else{
        this.filter.AccountsPayableCategoryCode = null;
        this.filter.AccountsReceivableCategoryCode = null;
      }
    },
    "filterAux.BankAccounts"(){
      this.filterOptions.Banks = this.filterAux.BankAccounts.map(elem => elem.Bank).filter((bank, index, self) => self.findIndex(b => b.Code === bank.Code) === index).sort((a, b) => a.Name.localeCompare(b.Name));
    },
    "filter.BankCode": function () {
      if(this.filter.BankCode){
        this.filterOptions.BankAccounts = this.filterAux.BankAccounts.filter(elem => elem.Bank.Code == this.filter.BankCode);
      }else{
        this.filterOptions.BankAccounts = this.filterAux.BankAccounts;
      }

      if (!this.filterOptions.BankAccounts.find(elem => elem.Code == this.filter.BankAccountsCode)) {
        this.filter.BankAccountsCode = null;
        this.filterBankAccountSearch = "";
      }
    },
    "filter.IsUnconciliated": function () {
      if(this.filter.IsUnconciliated){
        this.filterAux.AccountsCategory = null;
      }
    },
  },

  methods: {
    DefineColor(value){
      return value < 0 ? "red" : (value == 0 ? "#000080" : "green");
    },
    RemoveNegative(value){
      return value > 0 ? value : (value * -1)
    },
    FilterDefault: function () {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toJSON().split('T')[0];
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0).toJSON().split('T')[0];
      const defaultBankAccount = this.$route.params.BankAccountCode ? this.$route.params.BankAccountCode : null;
      const defaultIsUnconciliated = this.$route.params.IsUnconciliated ? this.$route.params.IsUnconciliated : false;
      return {
        BankCode: null,
        BankAccountsCode: defaultBankAccount,
        EntryTypeCode: null,
        DateInitial: firstDayOfMonth,
        DateEnd: lastDayOfMonth,
        AmountInitial: null,
        AmountEnd: null,
        Description: null,
        IsUnconciliated: defaultIsUnconciliated,
        AccountsPayableCategoryCode: null,
        AccountsReceivableCategoryCode: null
      }
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.hasSearched = true;
      this.ListBankConciliation();
    },

    ResetFilter() {
      this.filterAux.AccountsCategory = null;
      this.filterBankSearch = "";
      this.filterBankAccountSearch = "";
      this.categorySearch = "";
      this.filter = this.FilterDefault();
      if (this.hasSearched) {
        this.ListBankConciliation();
      }
    },

    GetParamsBankConciliation(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Bank.Code": this.filter.BankCode,
        "Object.BankAccountCode": this.filter.BankAccountsCode,
        "Object.EntryType.Code": this.filter.EntryTypeCode,
        "Object.Description": this.filter.Description,
        "DateInitial": this.filter.DateInitial,
        "DateEnd": this.filter.DateEnd,
        "AmountInitial": this.filter.AmountInitial,
        "AmountEnd": this.filter.AmountEnd,
        "IsUnconciliated": this.filter.IsUnconciliated,
        "AccountsPayableCategory.Code": this.filter.AccountsPayableCategoryCode,
        "AccountsReceivableCategory.Code": this.filter.AccountsReceivableCategoryCode
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListBankConciliation() {
      this.loading.BankConciliation = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });
      const params = this.GetParamsBankConciliation();
      this.$store.dispatch("ListBankConciliation", params)
        .then(response => {
          this.bankConciliationList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.bankConciliationList = [];
          this.pagination.TotalItems = 0;
          this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao listar as conciliações.", error);
        })
        .finally(() => (this.loading.BankConciliation = false));
    },

    OpenConciliateModal(selectedBankConciliation) {
      this.selectedBankConciliation = selectedBankConciliation;
      this.$bvModal.show("mConciliate");
    },

    ListBankAccounts() {
      this.loading.BankAccounts = true;
      let data = {
        "Object.Bank.Code": this.filter.BankCode,
      };
      return this.$store
        .dispatch("ListBankAccountsS2P", { params: data })
        .then((response) => {
          this.filterAux.BankAccounts = response;
          this.filterOptions.BankAccounts = this.filterAux.BankAccounts;
        })
        .catch((error) => {
          this.$makeToast("Tente novamente.", "danger", "Erro ao listar as contas bancárias", error);
        })
        .finally(() => (this.loading.BankAccounts = false));
    },

    ListEntryTypes() {
      this.loading.EntryType = true;
      return this.$store
        .dispatch("GetEntryTypes", {})
        .then(response => {
          this.filterOptions.EntryTypes = response;
        })
        .catch(error => {
          this.$makeToast("Tente novamente.", "danger", "Erro ao carregar os tipos de entrada", error);
        })
        .finally(() => (this.loading.EntryType = false));
    },

    ListPayableCategories() {
      this.loading.AccountsPayableCategory = true;
      return this.$store
        .dispatch("ListAccountsPayableCategory", {})
        .then((response) => {
          this.filterOptions.AccountsPayableCategory = response.Objects.sort((a, b) => a.Name.localeCompare(b.Name));
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar as categorias de pagamento", error);
        })
        .finally(() => (this.loading.AccountsPayableCategory = false));
    },

    ListReceivableCategories() {
      this.loading.AccountsReceivableCategories = true;
      return this.$store
        .dispatch("ListAccountsReceivableCategory", {})
        .then((response) => {
          this.filterOptions.AccountsReceivableCategory = response.Objects.sort((a, b) => a.Name.localeCompare(b.Name));
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar as categorias de recebimento", error);
        })
        .finally(() => (this.loading.AccountsReceivableCategories = false));
    },

  }
};


// WEBPACK FOOTER //
// ./src/components/pages/BankConciliation/BankConciliation.js